import Carousel from "./embla/carousel"

export default class Cards extends Carousel {
  constructor() {
    super()
    this.emblaNode = document.querySelectorAll(".icon-cards .embla, .image-cards .embla")

    if (!this.emblaNode.length) return

    this.emblaNode.forEach((node) => this.initCarousel(node))
  }
}
